import TypeToReducer from 'type-to-reducer';
import set from 'lodash/set';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import {
  RESET_NOTIFICATION_CONFIG_FORM,
  GET_NOTIFICATION_CONFIG_BY_ID,
  GET_NOTIFICATION_CONFIG_FORM_CONFIG,
  MODIFY_EDITING_NOTIFICATION_CONFIG,
  ADD_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG,
  MODIFY_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG, //Groups
  REMOVE_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG,
} from 'notifications_config/constants';

export const initialState = {
  isFetchingConfig: false,
  isFetching: false,
  isSaving: false,
  editing: { customFields: [], elements: [], _usersToNotify: [] },
};

export const resetForm = (state) => ({ ...initialState });

export const getByIdPending = (state) => ({ ...state, isFetching: true });

export const getByIdRejected = (state) => ({ ...state, isFetching: false });

export const getByIdFulfilled = (state, { payload }) => ({
  ...state,
  isFetching: false,
  editing: { ...payload.notification_config },
});

export const getConfigPending = (state) => ({ ...state, isFetchingConfig: true });
export const getConfigRejected = (state) => ({ ...state, isFetchingConfig: false });
export const getConfigFulfilled = (state) => ({ ...state, isFetchingConfig: false });

export const modifyNotificationConfig = (state, { payload }) => ({
  ...state,
  editing: {
    ...Object.keys(payload).reduce(
      (re, k) => {
        set(re, k, payload[k]);
        return re;
      },
      { ...state.editing }
    ),
  },
});

export const addCustomField = (state) => ({
  ...state,
  editing: {
    ...state.editing,
    customFields: [...state.editing.customFields, { key: '', label: '' }],
  },
});
export const removeCustomField = (state, { payload }) => ({
  ...state,
  editing: {
    ...state.editing,
    customFields: state.editing.customFields
      .map((c, i) => (i === payload ? { ...c, deleted: true } : { ...c }))
      .filter((c, i) => c._id || i !== payload),
  },
});

//Groups
export const modifyCustomField = (state, { payload }) => {
  findAndModify(state.editing._custom, payload);
  return {
    ...state,
    editing: {
      ...state.editing,
      ...payload,
    },
  };
};

export const findAndModify = (_custom, payload) => {
  const keys = Object.getOwnPropertyNames(payload);
  const key = keys[0];
  const value = payload[key];
  let banderaExiste = false;
  _custom.forEach((element) => {
    if (element.key == key) {
      element.value = value;
      banderaExiste = true;
    }
  });
  if (!banderaExiste) _custom.push({ key, value });
  return _custom;
};
//Groups

const reducers = {
  [RESET_NOTIFICATION_CONFIG_FORM]: resetForm,
  [GET_NOTIFICATION_CONFIG_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [GET_NOTIFICATION_CONFIG_FORM_CONFIG]: {
    [PENDING]: getConfigPending,
    [REJECTED]: getConfigRejected,
    [FULFILLED]: getConfigFulfilled,
  },
  [MODIFY_EDITING_NOTIFICATION_CONFIG]: modifyNotificationConfig,
  [ADD_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG]: addCustomField,
  [MODIFY_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG]: modifyCustomField, //Groups
  [REMOVE_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG]: removeCustomField,
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/reducers/notifications_config_form_reducers.js